import { NetCrackerSubscriptionsResponseType } from 'api/netCrackerAPI/netCrackerApiTypes';

export const mockGetCustomersList = () => {
  const res = {
    extensions: {
      listCustomers: {
        totalCount: 1,
      },
    },
    data: {
      listCustomers: [
        {
          id: '123',
        },
      ],
    },
  };
  return res;
};

export const mockGetCustomerProductsList = (): NetCrackerSubscriptionsResponseType => {
  return {
    extensions: {
      listProducts: {
        totalCount: 4,
      },
    },
    data: {
      listProducts: [
        {
          id: '1',
          name: '450 kr (Can raise limit) #1',
          status: 'ACTIVE',
          productFamily: {
            id: '1',
          },
          characteristic: [
            {
              id: '1',
              name: 'OCS Package ID',
              value: ['RDLIMIT5'],
              businessType: null,
            },
            {
              id: '1',
              name: 'OCS Price List ID',
              value: ['RDPRISDK14'],
              businessType: null,
            },
          ],
        },
        {
          id: '1',
          name: 'Barring Maritime Data #1',
          status: 'ACTIVE',
          productFamily: {
            id: '1',
          },
          characteristic: null,
        },
        {
          id: '1',
          name: 'Mobil 30 GB #1',
          status: 'ACTIVE',
          productFamily: {
            id: '5d8ec1da-d4d7-430d-908f-8143cccb0e8b',
          },
          characteristic: [
            {
              id: '70c0fadb-dcb5-477d-b68a-1bbe1c73c979',
              name: 'Phone Number',
              value: ['32323232'],
              businessType: 'PHONE_NUMBER',
            },
            {
              id: '1',
              name: 'Infrastructure Provider',
              value: ['TDC Net'],
              businessType: null,
            },
            {
              id: '1',
              name: 'OCS Welcome SMS ID',
              value: ['RLAHSMSP2'],
              businessType: null,
            },
            {
              id: '1',
              name: 'OCS Roaming Data Package ID',
              value: ['ROAM_FUL_PLUS_25600'],
              businessType: null,
            },
            {
              id: '1',
              name: 'ICCID',
              value: ['1'],
              businessType: 'SIM_CARD',
            },
            {
              id: '1',
              name: 'Roaming Enabled',
              value: ['True'],
              businessType: null,
            },
            {
              id: '1',
              name: 'International Phone Number',
              value: ['34343434'],
              businessType: 'INTERNATIONAL_PHONE_NUMBER',
            },
            {
              id: '1',
              name: 'IMSI',
              value: ['123456789012345'],
              businessType: null,
            },
            {
              id: '1',
              name: 'Information to public directory',
              value: ['List: Name, Address & Phone Number'],
              businessType: 'INFORMATION_TO_PUBLIC_DIRECTORY',
            },
            {
              id: '1',
              name: 'Mobile Service Type',
              value: ['Mobile Voice'],
              businessType: null,
            },
            {
              id: '1',
              name: 'SMS Enabled',
              value: ['True'],
              businessType: null,
            },
            {
              id: '1',
              name: 'SIM Type',
              value: ['eSIM'],
              businessType: 'SIM_TYPE',
            },
            {
              id: '1',
              name: 'OCS Mobile Payment ID',
              value: ['MPAYMENT'],
              businessType: null,
            },
            {
              id: '1',
              name: 'Voice Enabled',
              value: ['True'],
              businessType: null,
            },
            {
              id: '1',
              name: 'Mobile Line Type',
              value: ['Standalone'],
              businessType: 'MOBILE_LINE_TYPE',
            },
            {
              id: '1',
              name: 'Technology',
              value: ['5G'],
              businessType: null,
            },
            {
              id: '1',
              name: 'Data Enabled',
              value: ['True'],
              businessType: null,
            },
          ],
        },
        {
          id: '1',
          name: 'YouSee Musik #1',
          status: 'ACTIVE',
          productFamily: {
            id: '1',
          },
          characteristic: [
            {
              id: '1',
              name: 'OTT Type',
              value: ['yousee_musik'],
              businessType: 'OTT_TYPE',
            },
          ],
        },
      ],
    },
  };
};
